(function() {
  'use strict';

  // Helper to dynamically resolve assets on local dev or Shopify CDN
  function getAssetUrl(filename) {
    if (!filename) return '';
    const key = filename.split('?')[0].split('.')[0];
    if (window.VervAssets && window.VervAssets[key]) {
      return window.VervAssets[key];
    }
    return filename;
  }

  // --- 1. Pre-Launch Waitlist & Modal Logic ---
  const waitlistModal = document.getElementById('waitlist-modal');
  const waitlistModalOverlay = document.getElementById('waitlist-modal-overlay');
  const waitlistModalClose = document.getElementById('waitlist-modal-close');
  const waitlistModalForm = document.getElementById('waitlist-modal-form');
  const waitlistModalEmail = document.getElementById('waitlist-modal-email');
  const waitlistModalSuccess = document.getElementById('waitlist-modal-success');
  const waitlistFlavorName = document.getElementById('waitlist-flavor-name');
  const waitlistFlavorInput = document.getElementById('waitlist-flavor-input');
  const waitlistModalTitle = document.querySelector('.waitlist-modal-title');
  const waitlistModalDesc = document.querySelector('.waitlist-modal-desc');

  function openWaitlistModal(flavor) {
    if (!waitlistModal) return;
    if (waitlistFlavorName) waitlistFlavorName.textContent = flavor;
    if (waitlistFlavorInput) waitlistFlavorInput.value = flavor;
    
    // Show helper text and form input
    if (waitlistModalForm) waitlistModalForm.style.display = 'block';
    if (waitlistModalTitle) waitlistModalTitle.style.display = 'block';
    if (waitlistModalDesc) waitlistModalDesc.style.display = 'block';
    
    // Hide success message
    if (waitlistModalSuccess) waitlistModalSuccess.style.display = 'none';
    if (waitlistModalEmail) waitlistModalEmail.value = '';
    
    waitlistModal.classList.add('active');
    waitlistModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function showSuccessModal(flavor) {
    if (!waitlistModal) return;
    if (waitlistFlavorName) waitlistFlavorName.textContent = flavor;
    if (waitlistFlavorInput) waitlistFlavorInput.value = flavor;
    
    // Hide helpers and input form
    if (waitlistModalForm) waitlistModalForm.style.display = 'none';
    if (waitlistModalTitle) waitlistModalTitle.style.display = 'none';
    if (waitlistModalDesc) waitlistModalDesc.style.display = 'none';
    
    // Set success logo & cup source dynamically
    const waitlistSuccessLogo = document.querySelector('.waitlist-success-logo');
    const waitlistSuccessCupImg = document.getElementById('waitlist-success-cup-img');
    
    if (waitlistSuccessLogo) {
      waitlistSuccessLogo.src = getAssetUrl('verv_logo.png');
    }
    if (waitlistSuccessCupImg) {
      // Clear any custom multiple images first
      const wrapper = waitlistSuccessCupImg.parentElement;
      const existingMultiples = wrapper.querySelectorAll('.waitlist-success-cup-multi');
      existingMultiples.forEach(el => el.remove());
      
      if (flavor === 'Verv Noodles') {
        // Hide the single cup img element
        waitlistSuccessCupImg.style.display = 'none';
        
        // Create 3 separate overlapping cups (Chick'n, Spicy Miso, and Classic Miso)
        const cupFiles = ['cup_chicken.png', 'cup_spicy_miso.png', 'cup_miso.png'];
        cupFiles.forEach(file => {
          const img = document.createElement('img');
          img.src = getAssetUrl(file);
          img.alt = 'Ramen Cup';
          img.className = 'waitlist-success-cup-img waitlist-success-cup-multi';
          wrapper.appendChild(img);
        });
      } else {
        // Show the single cup img element
        waitlistSuccessCupImg.style.display = 'block';
        
        let cupFile = 'cup_spicy_miso.png'; // default
        const fLower = flavor.toLowerCase();
        if (fLower.includes('chick')) {
          cupFile = 'cup_chicken.png';
        } else if (fLower.includes('spicy')) {
          cupFile = 'cup_spicy_miso.png';
        } else if (fLower.includes('classic') || fLower.includes('miso')) {
          cupFile = 'cup_miso.png';
        }
        waitlistSuccessCupImg.src = getAssetUrl(cupFile);
        waitlistSuccessCupImg.alt = `${flavor} Cup`;
      }
    }
    
    // Update success title custom message
    if (waitlistModalSuccess) {
      const heading = waitlistModalSuccess.querySelector('h4');
      const paragraph = waitlistModalSuccess.querySelector('p');
      if (heading) {
        heading.textContent = "SLURP TIME.";
      }
      if (paragraph) {
        paragraph.textContent = "Check your inbox to see if you secured one of the first 100 FREE cups + grab your first-access updates.";
      }
      waitlistModalSuccess.style.display = 'block';
    }
    
    waitlistModal.classList.add('active');
    waitlistModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Add success-active class to modal container
    const container = waitlistModal.querySelector('.waitlist-modal-container');
    if (container) container.classList.add('success-active');
    
    // Auto-dismiss the success pop-up after 5 seconds
    setTimeout(() => {
      closeWaitlistModal();
    }, 5000);
  }

  function closeWaitlistModal() {
    if (!waitlistModal) return;
    waitlistModal.classList.remove('active');
    waitlistModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    
    // Remove success-active class from modal container
    const container = waitlistModal.querySelector('.waitlist-modal-container');
    if (container) container.classList.remove('success-active');
  }

  // Click handler for waitlist buttons
  document.querySelectorAll('.btn-waitlist-trigger').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const flavor = btn.getAttribute('data-flavor') || 'General';
      openWaitlistModal(flavor);
    });
  });

  if (waitlistModalClose) waitlistModalClose.addEventListener('click', closeWaitlistModal);
  if (waitlistModalOverlay) waitlistModalOverlay.addEventListener('click', closeWaitlistModal);

  // Close waitlist modal on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && waitlistModal && waitlistModal.classList.contains('active')) {
      closeWaitlistModal();
    }
  });

  // --- 2. Klaviyo AJAX Submission ---
  function submitToKlaviyo(email, flavor = '') {
    const listId = 'Vj6WBS';
    const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
    
    const params = new URLSearchParams();
    params.append('g', listId);
    params.append('email', email);
    
    if (flavor) {
      params.append('$custom_properties', JSON.stringify({ 'Flavor': flavor }));
    }
    
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      body: params.toString()
    })
    .then(response => response.json())
    .then(data => {
      console.log('Klaviyo subscription success:', data);
      return data;
    })
    .catch(error => {
      console.error('Klaviyo subscription error:', error);
      return { success: true };
    });
  }

  // --- 3. Interactive Hero Cup Rotator & Background Colors ---
  const cupWrappers = [
    document.getElementById('cup-wrap-1'),
    document.getElementById('cup-wrap-2'),
    document.getElementById('cup-wrap-3')
  ];

  let currentActiveFlavor = 'Spicy Miso';

  if (cupWrappers.every(el => el)) {
    let positions = ['pos-left', 'pos-center', 'pos-right'];
    let rotationInterval = null;

    const updatePositions = () => {
      cupWrappers.forEach((el, index) => {
        el.classList.remove('pos-left', 'pos-center', 'pos-right');
        el.classList.add(positions[index]);
      });
      // Update background color class based on the centered flavor cup
      const htmlEl = document.documentElement;
      const heroEl = document.getElementById('hero');
      const themeColorMeta = document.getElementById('theme-color-meta');
      
      let newClass = '';
      let hexColor = '';
      if (positions[0] === 'pos-center') {
        currentActiveFlavor = 'Classic Miso';
        newClass = 'bg-purple';
        hexColor = '#6d3285';
      } else if (positions[1] === 'pos-center') {
        currentActiveFlavor = 'Spicy Miso';
        newClass = 'bg-red';
        hexColor = '#d33200';
      } else if (positions[2] === 'pos-center') {
        currentActiveFlavor = "Chick'n";
        newClass = 'bg-yellow';
        hexColor = '#d5a022';
      }

      if (newClass) {
        const classesToRemove = ['bg-purple', 'bg-red', 'bg-yellow'].filter(c => c !== newClass);
        if (htmlEl) {
          htmlEl.classList.remove(...classesToRemove);
          htmlEl.classList.add(newClass);
          
          let edgeColor = '';
          let gradColor = '';
          if (newClass === 'bg-purple') {
            edgeColor = '#6d3285';
            gradColor = 'radial-gradient(circle at center, #833ca1 20%, #6d3285 75%)';
          } else if (newClass === 'bg-red') {
            edgeColor = '#d33200';
            gradColor = 'radial-gradient(circle at center, #ff3c00 20%, #d33200 75%)';
          } else if (newClass === 'bg-yellow') {
            edgeColor = '#d5a022';
            gradColor = 'radial-gradient(circle at center, #fabc2a 20%, #d5a022 75%)';
          }
          
          htmlEl.style.setProperty('background-color', edgeColor, 'important');
          htmlEl.style.setProperty('background-image', gradColor, 'important');
          htmlEl.style.setProperty('background-repeat', 'no-repeat', 'important');
          htmlEl.style.setProperty('background-size', '100% 100%', 'important');
          
          if (document.body) {
            document.body.style.setProperty('background-color', edgeColor, 'important');
            document.body.style.setProperty('background-image', gradColor, 'important');
            document.body.style.setProperty('background-repeat', 'no-repeat', 'important');
            document.body.style.setProperty('background-size', '100% 100%', 'important');
          }
          
          if (heroEl) {
            if (window.innerWidth <= 768 || window.innerHeight <= 700) {
              heroEl.style.setProperty('background-image', 'none', 'important');
              heroEl.style.setProperty('background-color', 'transparent', 'important');
            } else {
              heroEl.style.removeProperty('background-image');
              heroEl.style.removeProperty('background-color');
            }
          }
        }
        if (heroEl) {
          heroEl.classList.remove(...classesToRemove);
          heroEl.classList.add(newClass);
        }
        if (themeColorMeta) {
          themeColorMeta.setAttribute('content', hexColor);
        }
      }
    };

    const startAutoRotate = () => {
      if (rotationInterval) clearInterval(rotationInterval);
      rotationInterval = setInterval(() => {
        // Shift array clockwise (right cup moves center, center moves left, left moves right)
        positions.unshift(positions.pop());
        updatePositions();
      }, 4500);
    };

    // Attach click events to make left/right cups clickable
    cupWrappers.forEach((wrapper, clickedIndex) => {
      wrapper.addEventListener('click', () => {
        const currentClass = positions[clickedIndex];
        
        if (currentClass === 'pos-left') {
          // Rotate counter-clockwise (left moves to center)
          positions.push(positions.shift());
          updatePositions();
          startAutoRotate(); // Restart timer
        } else if (currentClass === 'pos-right') {
          // Rotate clockwise (right moves to center)
          positions.unshift(positions.pop());
          updatePositions();
          startAutoRotate(); // Restart timer
        }
      });
    });

    // Start initial auto rotation
    startAutoRotate();
    
    // Sync positions on resize/rotation
    window.addEventListener('resize', updatePositions);
  }

  // --- 4. Form Submit Listeners ---
  function handleFormSuccess(form, flavor) {
    if (!form) return;
    const actionsContainer = form.closest('.hero-actions-container') || form.closest('.hero-waitlist-box') || form.parentElement;
    if (actionsContainer) {
      actionsContainer.innerHTML = `
        <div class="hero-inline-success" style="color: #FFF6ED !important;">
          <span class="inline-success-icon" style="color: #FFF6ED !important;">🎉</span>
          <span class="inline-success-text" style="color: #FFF6ED !important; font-weight: 500;">
            <strong style="color: #FFF6ED !important; font-weight: 900; margin-right: 6px;">YOU'RE ON THE LIST!</strong>Check your inbox to claim your free cup.
          </span>
        </div>
      `;
    }
    showSuccessModal(flavor);
  }

  if (waitlistModalForm) {
    waitlistModalForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = waitlistModalEmail ? waitlistModalEmail.value.trim() : '';
      const flavor = waitlistFlavorInput ? waitlistFlavorInput.value : 'Verv Noodles';
      if (!email) return;
      
      submitToKlaviyo(email, flavor);
      showSuccessModal(flavor);
    });
  }

  const allHeroSignupForms = document.querySelectorAll('form');
  allHeroSignupForms.forEach((form) => {
    const input = form.querySelector('input[type="email"], .hero-signup-input');
    if (!input) return;

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = input.value.trim();
      if (!email) return;
      
      const flavor = typeof currentActiveFlavor !== 'undefined' ? currentActiveFlavor : 'Verv Noodles';
      submitToKlaviyo(email, flavor);
      
      if (typeof ttq !== 'undefined') {
        ttq.track('CompleteRegistration', {
          content_name: 'Hero Waitlist',
          content_category: flavor,
          value: 0,
          currency: 'USD'
        });
      }
      
      handleFormSuccess(form, flavor);
    });
  });

  // Explicit click handler on buttons to ensure submit event triggers even if drawer elements intercept click
  document.querySelectorAll('.hero-signup-submit, .hero-btn-container, .hero-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const form = btn.closest('form');
      if (form) {
        const input = form.querySelector('input[type="email"], .hero-signup-input');
        if (input && input.value.trim()) {
          e.preventDefault();
          const submitEvent = new Event('submit', { cancelable: true, bubbles: true });
          form.dispatchEvent(submitEvent);
        }
      }
    });
  });
})();
